import React, { createContext, useContext, useEffect, useState } from 'react'
import server from '../server'

export const BrandingContext = createContext()

const extractHostname = (domainOrUrl) => {
  if (!domainOrUrl || typeof domainOrUrl !== 'string') return null
  const trimmed = domainOrUrl.trim().toLowerCase()
  try {
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      return new URL(trimmed).hostname
    }
    return trimmed
  } catch {
    return trimmed
  }
}

export const BrandingContextProvider = ({ children }) => {
  const [branding, setBranding] = useState(null)
  const [domainForLogin, setDomainForLogin] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const isGroupMode = !!branding

  useEffect(() => {
    const detectAndFetchBranding = async () => {
      const hostname = window.location.hostname
      const envDomain = process.env.REACT_APP_PHARMACY_GROUP_DOMAIN
        ? extractHostname(process.env.REACT_APP_PHARMACY_GROUP_DOMAIN)
        : null

      const domainToUse = hostname && hostname !== 'localhost' ? hostname : envDomain
      if (!domainToUse) {
        setIsLoading(false)
        return
      }

      try {
        const response = await server.get(
          `/pharmacyGroups/branding?domain=${encodeURIComponent(domainToUse)}`
        )
        const data = response.data

        if (data.branding) {
          setDomainForLogin(domainToUse)
          setBranding({
            ...data.branding,
            displayName: data.branding.displayName || data.branding.name || 'OpenRx',
            isGroupMode: true,
          })
        } else {
          setBranding(null)
          setDomainForLogin(null)
        }
      } catch (err) {
        console.error('[BrandingContext] Error fetching branding:', err)
        setError(err)
        setBranding(null)
        setDomainForLogin(null)
      } finally {
        setIsLoading(false)
      }
    }

    detectAndFetchBranding()
  }, [])

  const value = {
    branding,
    isGroupMode,
    isLoading,
    error,
    displayName: branding?.displayName || branding?.name || 'Origins Management',
    logo: branding?.logo,
    favicon: branding?.favicon,
    loginBackground: branding?.loginBackground,
    primaryColor: branding?.primaryColor,
    secondaryColor: branding?.secondaryColor,
    domain: branding?.domain,
    domainForLogin,
  }

  return (
    <BrandingContext.Provider value={value}>
      {isLoading ? (
        <div className='loading-container dark:bg-dark' style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span className='spinner'></span>
        </div>
      ) : (
        children
      )}
    </BrandingContext.Provider>
  )
}

export const useBranding = () => {
  const context = useContext(BrandingContext)
  if (!context) {
    throw new Error('useBranding must be used within BrandingContextProvider')
  }
  return context
}
